<ng-container *ngIf="$company | async as company">
  <div class="mb-[30px]">
    <h1 class="company-info__name" data-test-id="company-name-element">{{ company.name }}</h1>
    <p class="company-info__description whitespace-pre-line	empty:hidden" data-test-id="company-description-element">{{ company.description }}</p>
  </div>
  <a
    *ngIf="company.companyHomepage"
    pm-button
    data-test-id="company-homepage-element"
    class="company-info__homepage max-xs:!text-[14px]"
    [href]="company.companyHomepage"
    [pmType]="'link'"
    target="_blank"
    >{{ company.companyHomepage }}</a>
</ng-container>
